import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import all translation files
import deCommon from '../locales/de/common.json';
import deNavigation from '../locales/de/navigation.json';
import dePages from '../locales/de/pages.json';
import deComponents from '../locales/de/components.json';
import deBusiness from '../locales/de/business.json';

import enCommon from '../locales/en/common.json';
import enNavigation from '../locales/en/navigation.json';
import enPages from '../locales/en/pages.json';
import enComponents from '../locales/en/components.json';
import enBusiness from '../locales/en/business.json';

export const supportedLanguages = ['de', 'en'] as const;
export type SupportedLanguage = typeof supportedLanguages[number];

const resources = {
  de: {
    common: deCommon,
    navigation: deNavigation,
    pages: dePages,
    components: deComponents,
    business: deBusiness
  },
  en: {
    common: enCommon,
    navigation: enNavigation,
    pages: enPages,
    components: enComponents,
    business: enBusiness
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'de', // German as fallback
    supportedLngs: supportedLanguages,
    
    // Namespaces
    defaultNS: 'common',
    ns: ['common', 'navigation', 'pages', 'components', 'business'],
    
    // Detection options
    detection: {
      order: ['path', 'localStorage', 'navigator'],
      lookupFromPathIndex: 0,
      caches: ['localStorage'],
      excludeCacheFor: ['cimode'],
      
      // Custom path detection
      lookupFromSubdomainIndex: 0,
      
      // Check if language is in the URL path
    },
    
    interpolation: {
      escapeValue: false // React already escapes values
    },
    
    react: {
      useSuspense: false // Disable suspense for better control
    },
    
    debug: false // Set to true for development debugging
  });

export default i18n;